export const spacing = [0, 5, 10, 15, 20, 25, 30, 45, 60]
